import { get } from "lodash";
import FieldWrapper from "../components/FieldWrapper";
import { MatrixFieldType } from "../types/feedbackFields.types";
import { FieldProps } from "./fields.types";

// TODO: handle required
const MatrixField = ({ field, error, data, onChange }: { field: MatrixFieldType } & FieldProps) => {
  const { _id, name, required, choices = [], lines = [] } = field;
  const id = _id || name;

  const labelWidth = choices.length > 5 ? 35 : 40;
  const cellWidth = Math.round((100 - labelWidth) / choices.length);

  return (
    <FieldWrapper field={field} error={error}>
      <div id={id} className="c-matrix">
        <div className="c-matrix__header">
          <div className="c-matrix__cell" style={{ width: `${labelWidth}*` }}></div>
          {choices.map((choice, index) => (
            <div key={index} className="c-matrix__cell" style={{ width: `${cellWidth}%` }}>
              {choice.text}
            </div>
          ))}
        </div>
        {lines.map((line, lineIndex) => {
          const value = get(data, line._id);
          return (
            <div key={lineIndex} className="c-matrix__line">
              <div
                className="c-matrix__cell"
                style={{
                  textAlign: "left",
                  paddingLeft: line.text?.[0] === " " ? 8 : undefined,
                  fontSize: line.text?.[0] === " " ? "0.9em" : undefined,
                }}
              >
                {line.text}
              </div>
              {!line.isHeader &&
                choices.map((choice, index) => (
                  <div key={index} className="c-matrix__cell">
                    {!line.isHeader && (
                      <input
                        type="radio"
                        name={line._id}
                        value={choice.text}
                        checked={value === choice.value}
                        onChange={(e) => onChange([line._id], choice.value)}
                        required={required}
                      />
                    )}
                  </div>
                ))}
            </div>
          );
        })}
      </div>
    </FieldWrapper>
  );
};
export default MatrixField;
